import { createContext, useContext } from "react";

export const ExtraFieldsContext = createContext({
  extraFields: [],
  setExtraFields: () => {},
});
export const useExtraFieldsContext = () => useContext(ExtraFieldsContext);
